import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../Login/LoginPage.css';
import './Signup.css';
import signupImageDark from '../../../Assets/Team/login-imagee.png';
import signupImageLight from '../../../Assets/Team/login-light-image.png';
import { useModal } from '../../../context/ModalContext.jsx';
import { ArrowRight,Headphones,Mail,Moon,Phone,ShieldCheck,Sun,User,ChevronDown,} from 'lucide-react';

const config = {
  cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
  ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA==',
};

// Hero copy — cycles between Hindi and English every few seconds
const HERO_TEXT = {
  hi: {
    titleLine1: 'नेटवर्क से',
    titleLine2: 'जुड़ें आज ही',
    subtitleLine1: 'दुर्घटना सहायता, ब्रेकडाउन और रिकवरी,',
    subtitleLine2: 'सब एक ही जगह।',
  },
  en: {
    titleLine1: 'Join the',
    titleLine2: 'network today',
    subtitleLine1: 'Accident support, breakdown & recovery,',
    subtitleLine2: 'all in one place.',
  },
};

const HERO_SWITCH_INTERVAL_MS = 3500;

const SignUp = () => {
  const navigate = useNavigate();
  const { openModal, modalData, closeModal } = useModal();

  const [darkMode, setDarkMode] = useState(true);

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingStates, setIsLoadingStates] = useState(true);
  const [isLoadingCities, setIsLoadingCities] = useState(true);
  const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });

  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  // Hero language toggle (Hindi <-> English)
  const [showEnglish, setShowEnglish] = useState(false);
  const activeHero = showEnglish ? HERO_TEXT.en : HERO_TEXT.hi;

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    loadStates();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowEnglish((prev) => !prev);
    }, HERO_SWITCH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const loadStates = () => {
    setIsLoadingStates(true);
    fetch(`${config.cUrl}/states`, {
      headers: { 'X-CSCAPI-KEY': config.ckey },
    })
      .then((response) => response.json())
      .then((data) => {
        setStates(data);
        setIsLoadingStates(false);
      })
      .catch((error) => {
        console.error('Error loading states:', error);
        setIsLoadingStates(false);
      });
  };

  const openLink = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const loadCities = (stateCode) => {
    setIsLoadingCities(true);
    fetch(`${config.cUrl}/states/${stateCode}/cities`, {
      headers: { 'X-CSCAPI-KEY': config.ckey },
    })
      .then((response) => response.json())
      .then((data) => {
        setCities(data);
        setIsLoadingCities(false);
      })
      .catch((error) => {
        console.error('Error loading cities:', error);
        setIsLoadingCities(false);
      });
  };

  const [formData, setFormData] = useState({
    FullName: '',
    phone: '',
    joinInType: '',
    vendorType: '',
    customerType: '',
    email: '',
  });

  useEffect(() => {
    if (latitude !== '') {
      setFormData((prev) => ({ ...prev, latitude }));
    }
  }, [latitude]);

  useEffect(() => {
    if (longitude !== '') {
      setFormData((prev) => ({ ...prev, longitude }));
    }
  }, [longitude]);

  const fullAddress = `${formData.address}, ${formData.district},${formData.pincode}, ${formData.state}`;
  const geoUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(fullAddress)}`;

  useEffect(() => {
    const getLonLat = async () => {
      try {
        const response = await axios.get(geoUrl);
        const location = response.data[0];
        setLatitude(location.lat);
        setLongitude(location.lon);
      } catch (error) {
        // silently ignore — address isn't collected in this flow yet
      }
    };
    getLonLat();
  }, [fullAddress]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === 'phone') {
      updatedValue = value.replace(/\D/g, '');
      if (updatedValue && updatedValue[0].match(/[6-9]/)) {
        updatedValue = updatedValue.slice(0, 10);
      } else {
        updatedValue = '';
      }
      setFormData({ ...formData, [name]: updatedValue });
      return;
    }

    if (name === 'email') {
      setFormData((prev) => ({ ...prev, [name]: value }));
      return;
    }

    if (name === 'FullName') {
      updatedValue = value
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    }

    setFormData((prev) => ({ ...prev, [name]: updatedValue }));
  };

  const validateForm2 = () => {
    const { customerType, vendorType, ...otherFields } = formData;

    if (formData.joinInType === 'Customer' && formData.customerType === '') {
      return 'The field Customer type is required.';
    }
    if (formData.joinInType === 'Vendor' && formData.vendorType === '') {
      return 'The field Vendor type is required.';
    }

    for (const [key, value] of Object.entries(otherFields)) {
      if (key !== 'email' && value === '') {
        return `The field '${key}' is required.`;
      }
    }
  };

  const validatePhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  const handleRoleChange = (e) => {
    setFormData({ ...formData, joinInType: e.target.value });
    if (modalData.isOpen) closeModal();
  };

  const handleCustomerTypeChange = (e) => {
    setFormData({ ...formData, customerType: e.target.value });
    if (modalData.isOpen) closeModal();
  };

  const handleVendorTypeChange = (e) => {
    setFormData({ ...formData, vendorType: e.target.value });
    if (modalData.isOpen) closeModal();
  };

  const fullNameInputRef = useRef(null);
  const phoneInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const joinInTypeInputRef = useRef(null);
  const customerTypeInputRef = useRef(null);
  const vendorTypeInputRef = useRef(null);
  const btnSubmit = useRef(null);

  const [errorInputName, setErrorInputName] = useState(null);

  useEffect(() => {
    const refMap = {
      email: emailInputRef,
      FullName: fullNameInputRef,
      phone: phoneInputRef,
      joinInType: joinInTypeInputRef,
      customerType: customerTypeInputRef,
      vendorType: vendorTypeInputRef,
    };
    const ref = refMap[errorInputName];
    if (!ref) return;

    if (modalData.isOpen) {
      ref.current?.focus();
    } else {
      setTimeout(() => ref.current?.focus(), 10);
    }
  }, [modalData.isOpen, errorInputName]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.key === 'Escape' || e.key === ' ' || e.key === 'Enter') && !modalData.isOpen) {
        closeModal();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [modalData.isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorInputName(null);

    if (!formData.FullName || formData.FullName.trim() === '') {
      setErrorInputName('FullName');
      openModal({ title: 'Error', body: 'Please enter valid name', iconType: 'error', autoClose: true });
      return;
    }

    if (!validatePhone(formData.phone)) {
      setErrorInputName('phone');
      openModal({ title: 'Error', body: 'Please enter valid phone Number', iconType: 'error', autoClose: true });
      return;
    }

    const validationMessage = validateForm2();
    if (validationMessage) {
      setAlertInfo({ show: true, message: validationMessage, severity: 'error' });

      if (validationMessage.includes('joinInType')) {
        setErrorInputName('joinInType');
        openModal({ title: 'Error', body: 'Please select a role', iconType: 'error', autoClose: true });
        return;
      }
      if (validationMessage.includes('Customer type')) {
        setErrorInputName('customerType');
        openModal({ title: 'Error', body: 'Please select a role type', iconType: 'error', autoClose: true });
        return;
      }
      if (validationMessage.includes('Vendor type')) {
        setErrorInputName('vendorType');
        openModal({ title: 'Error', body: 'Please select a role type', iconType: 'error', autoClose: true });
        return;
      }
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/signupByUser`,
        data: formData,
      });

      if (response.status === 200 || response.status === 201) {
        setIsLoading(false);
        setErrorInputName(null);

        openModal({
          title: 'Success',
          body: 'Registration completed! Please click below to log in.',
          iconType: 'success',
          autoClose: false,
          actionLabel: 'Log In',
          onAction: () => {
            navigate('/LoginPage');
            closeModal();
          },
        });

        setFormData({});
      }

      if (response.data.message === 'We Have An Existing Email !!!') {
        setIsLoading(false);
        setAlertInfo({ show: true, message: response.data.message, severity: 'error' });
        openModal({ title: 'Error', body: response.data.message, iconType: 'error', autoClose: true });
      }
    } catch (error) {
      setIsLoading(false);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
      openModal({ title: 'Error', body: errorMessage, iconType: 'error', autoClose: true });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fullNameInputRef.current?.focus();
  }, []);

  useEffect(() => {
    const newNumber = localStorage.getItem('newNumber');
    if (newNumber) {
      setFormData((prev) => ({ ...prev, phone: newNumber }));
    }
  }, []);

  return (
    <div className={`claimpro-login signup-page ${darkMode ? 'dark' : 'light'}`}>
      {/* ================= TOP BAR ================= */}

      <header className="login-header">
        <div className="login-logo">
          <img
            src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png"
            alt="ClaimPro Assist"
          />
        </div>

        <div className="login-header-actions">
          <button className="help-button">
            <Headphones size={16} />
            <span>Need Help?</span>
          </button>

          <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)} aria-label="Toggle theme">
            <span className={!darkMode ? 'active' : ''}>
              <Sun size={15} />
            </span>
            <span className={darkMode ? 'active' : ''}>
              <Moon size={15} />
            </span>
          </button>
        </div>
      </header>

      {/* ================= MAIN ================= */}

      <main className="login-main">
        {/* ================= LEFT HERO ================= */}

        <section className="login-hero">
          <div className="hero-content">
            <div className="hero-eyebrow">
              <span />
              CLAIMPRO ASSIST NETWORK
            </div>

            <h1 key={showEnglish ? 'title-en' : 'title-hi'} className="hero-text-swap" lang={showEnglish ? 'en' : 'hi'}>
              {activeHero.titleLine1}
              <br />
              <span>{activeHero.titleLine2}</span>
            </h1>

            <p
              key={showEnglish ? 'sub-en' : 'sub-hi'}
              className="hero-subtitle hero-text-swap"
              lang={showEnglish ? 'en' : 'hi'}
            >
              {activeHero.subtitleLine1}
              <br />
              {activeHero.subtitleLine2}
            </p>

            <div className="network-status" style={{ marginTop: '32px' }}>
              <div className="network-dot" />
              <div>
                <strong>CLAIMPRO NETWORK</strong>
                <span>24/7 roadside assistance across India</span>
              </div>
            </div>
          </div>

          <div className="hero-image">
            <img src={darkMode ? signupImageDark : signupImageLight} alt="Join ClaimPro Assist network" />
          </div>
        </section>

        {/* ================= SIGNUP SIDE ================= */}

        <section className="login-side">
          <div className="login-card">
            {/* Card Header */}
            <div className="login-card-header">
              <div className="welcome-label">GET STARTED</div>
              <h2>Create your account</h2>
              <p>Join the ClaimPro Assist network in a few steps</p>
            </div>

            {/* Login link */}
            <div className="signup-text">
              Already have an account?
              <Link to="/LoginPage">Log in</Link>
            </div>

            <form onSubmit={handleSubmit}>
              {/* ================= FULL NAME ================= */}
              <div className="input-group">
                <label>Full Name</label>
                <div className={`modern-input ${errorInputName === 'FullName' ? 'input-error' : ''}`}>
                  <User size={17} />
                  <input
                    ref={fullNameInputRef}
                    type="text"
                    id="FullName"
                    name="FullName"
                    required
                    value={formData.FullName || ''}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        btnSubmit.current.click();
                        if (modalData.isOpen) closeModal();
                      }
                    }}
                  />
                </div>
              </div>

              {/* ================= MOBILE ================= */}
              <div className="input-group">
                <label>Mobile Number</label>
                <div className={`modern-input ${errorInputName === 'phone' ? 'input-error' : ''}`}>
                  <div className="country-code">+91</div>
                  <Phone size={17} />
                  <input
                    ref={phoneInputRef}
                    type="text"
                    id="phone"
                    name="phone"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    required
                    maxLength={10}
                    value={formData.phone || ''}
                    onChange={handleChange}
                    placeholder="Enter 10 digit mobile number"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        btnSubmit.current.click();
                        if (modalData.isOpen) closeModal();
                      }
                    }}
                  />
                </div>
              </div>

              {/* ================= ROLE ================= */}
              <div className="input-group">
                <label>Role</label>
                <div
                  className={`modern-input select-input ${errorInputName === 'joinInType' ? 'input-error' : ''}`}
                >
                  <User size={17} />
                  <select
                    ref={joinInTypeInputRef}
                    className="modern-select"
                    id="joinInType"
                    name="joinInType"
                    required
                    value={formData.joinInType}
                    onChange={handleRoleChange}
                  >
                    <option value="">Select your role</option>
                    <option value="Customer">Customer</option>
                    <option value="Vendor">Service Provider</option>
                  </select>
                  <ChevronDown size={16} className="select-chevron" />
                </div>
              </div>

              {/* ================= ROLE TYPE — CUSTOMER ================= */}
              {formData.joinInType === 'Customer' && (
                <div className="input-group">
                  <label>Role Type</label>
                  <div
                    className={`modern-input select-input ${
                      errorInputName === 'customerType' ? 'input-error' : ''
                    }`}
                  >
                    <User size={17} />
                    <select
                      ref={customerTypeInputRef}
                      className="modern-select"
                      id="customerType"
                      name="customerType"
                      required
                      value={formData.customerType}
                      onChange={handleCustomerTypeChange}
                    >
                      <option value="">Select role type</option>
                      <option value="retail">Individual</option>
                      <option value="fleetOwner">Company</option>
                    </select>
                    <ChevronDown size={16} className="select-chevron" />
                  </div>
                </div>
              )}

              {/* ================= ROLE TYPE — VENDOR ================= */}
              {formData.joinInType === 'Vendor' && (
                <div className="input-group">
                  <label>Role Type</label>
                  <div
                    className={`modern-input select-input ${
                      errorInputName === 'vendorType' ? 'input-error' : ''
                    }`}
                  >
                    <User size={17} />
                    <select
                      ref={vendorTypeInputRef}
                      className="modern-select"
                      id="vendorType"
                      name="vendorType"
                      required
                      value={formData.vendorType}
                      onChange={handleVendorTypeChange}
                    >
                      <option value="">Select role type</option>
                      <option value="crane">Crane Service</option>
                      <option value="mechanic">Mechanic Service</option>
                      <option value="recoveryVan">Recovery Van Service</option>
                    </select>
                    <ChevronDown size={16} className="select-chevron" />
                  </div>
                </div>
              )}

              {/* ================= EMAIL (optional) ================= */}
              <div className="input-group">
                <label>Email (optional)</label>
                <div className={`modern-input ${errorInputName === 'email' ? 'input-error' : ''}`}>
                  <Mail size={17} />
                  <input
                    ref={emailInputRef}
                    type="text"
                    id="email"
                    name="email"
                    value={formData.email || ''}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        btnSubmit.current.click();
                        if (modalData.isOpen) closeModal();
                      }
                    }}
                  />
                </div>
              </div>

              {/* ================= POLICIES ================= */}
              <div className="policy-text">
                <p>
                  By registering, you agree to our{' '}
                  <span onClick={() => openLink('/terms_&_condition')}>Terms &amp; Conditions</span> and{' '}
                  <span onClick={() => openLink('/privacy-policy')}>Privacy Policy</span>
                </p>
                <p>
                  <span onClick={() => openLink('/delete-account-page')}>Account Deletion Policy</span>
                  {' • '}
                  <span onClick={() => openLink('/cancellation-refund-policy')}>Cancellation &amp; Refund</span>
                </p>
              </div>

              {/* ================= SUBMIT ================= */}
              <button ref={btnSubmit} type="submit" className="login-submit">
                {isLoading ? (
                  <span className="button-spinner" />
                ) : (
                  <>
                    Create Account
                    <ArrowRight size={18} />
                  </>
                )}
              </button>

              {/* Security */}
              <div className="security-note">
                <ShieldCheck size={17} />
                <span>Your information is securely encrypted</span>
              </div>
            </form>
          </div>
        </section>
      </main>
    </div>
  );
};

export default SignUp;